import { CodeDesignation } from '../../../models/codeDesignation.model';

/**
 * Dto qui transmet les messages aux utilisateurs dans les différentes langues.
 */
export class CommunicationUtilisateurParLangueDto {
	langue: CodeDesignation;
	message: string;

	constructor(langue?: CodeDesignation, message?: string) {
		this.langue = langue;
		this.message = message;
	}

	/**
	 * Retourne true si la langue du message est le français.
	 */
	estFrancais(): boolean {
		return this.langue.code === 'fr';
	}

	serialize(): any {
		return Object.assign({}, this);
	}

	deserialize(input: any): CommunicationUtilisateurParLangueDto {
		Object.assign(this, input);
		return this;
	}
}
